

import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { updateTopluNakliyeCityIklimIndexExcel } from "../../../features/nakliyeIndex/nakliyeIndexSlice"
import { validateExcelFile } from "../../../helper/docs/validateExcelFile"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: 600px;
        overflow: auto;

        .content{
            margin: 40px;
            margin-bottom: 10px;
            padding: 30px;
            width: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            border-radius: 20px;
            gap: 40px;

            h2{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-lg);
            }

            .input-grp{
                display: flex;
                align-items: center;
                gap: 30px;

                .file-input-label{
                    width: auto;
                    padding: 0 15px;
                    line-height: 40px;
                    text-align: center;
                    height: 40px;
                    color: ${({ theme }) => theme.mainTextColor};
                    border-radius: 10px;
                    font-weight: var(--font-weight-lg);
                    font-size: 16px;
                    border: 1px solid;
                    cursor: pointer;
                    border-color: ${({ theme }) => theme.contrastColor};
                }

                .file-name{
                    font-weight: var(--font-weight-md);
                    font-size: 14px;
                }

                .file-input{
                    display: none;
                }
            }
        }

        .error-messages{
            display: flex;
            flex-direction: column;
            gap: 2px;

            h3{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-decoration: underline;
                padding-bottom: 5px;
            }

            .message-item{
                font-size: 12px;
                font-weight: var(--font-weight-md);
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
        }
    }
`
const NakliyeIndexCityTownIklimAddExcelModal = () => {

    const location = useLocation()
    const dispatch = useDispatch()

    const {modalLocation } = useSelector(state => state.modal)
    const {isLoadingUpdateTopluNakliyeCityIklimIndexExcel}= useSelector(state => state.nakliyeIndex)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [doc, setDoc] = useState(null)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = async(e) => {

        const file = await validateExcelFile({file: e.target.files[0], maxSize: 5 * 1024 * 1024, allowedTypes: ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"]})

        if(file){
            setDoc(e.target.files[0])
        }
    }

    const handleSubmit = () => {
        if(doc){
            dispatch(updateTopluNakliyeCityIklimIndexExcel(doc))
        }
    }


  return (
    <ModalContainer>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Excelden Toplu Kaydet"}/>
        <div className="content">
            <h2>Excelden Toplu Kaydet</h2>
            <div className="input-grp">
               <label className="file-input-label" htmlFor="kimlikFile">Dosya Seç</label>
                <div className="file-name">{doc?.name || "Belge Seçin"}</div>
                <input type="file" id="kimlikFile" className='file-input' onChange={handleChange} />
                <Btn color={"#F4F4F4"} bgColor={"#E85446"} radius={"10px"} width={"200px"} handleClick={handleSubmit}>
                    {isLoadingUpdateTopluNakliyeCityIklimIndexExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/>: "Kaydet"}
                </Btn>
            </div>
        </div>
        <div className='button-grp'>
            <Btn color={"#E85446"} bgColor={"transparent"} borderColor="#E85446" width="220px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default NakliyeIndexCityTownIklimAddExcelModal
